import { Button as AntdButton } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled(AntdButton)`
  display: flex;
  height: 100%;
  width: ${props => props.fullwidth ? '100%' : 'auto'};
  align-items: center;
  justify-content: center;

  /* Brand primary: #008939 with #FFFFFF (WCAG AA for controls). Span/.anticon: antd + index.css span. */
  &.ant-btn-primary {
    background: #008939;
    border: none;
    color: #ffffff;
  }

  &.ant-btn-primary:hover,
  &.ant-btn-primary:focus {
    background: #007532;
    border: none;
    color: #ffffff;
  }

  &.ant-btn-primary:active {
    background: #006b2d;
    border: none;
    color: #ffffff;
  }

  &.ant-btn-primary span,
  &.ant-btn-primary .anticon {
    color: #ffffff;
  }

  &.ant-btn-default {
    border: 1px solid white;
    background: transparent;
  }

  &[disabled], &[disabled]:hover {
    background: #c0c0c0;
    color: #727272;

    span,
    .anticon {
      color: #727272;
    }

    a {
      color: #727272;
    }
  }

  &, :hover, :focus {
    float: left;
    font-size: 25px;
    padding: 0 1.25em;
    min-height: ${props => props.size === 'large' ? '70px' : '57px'};
    border-radius: 0.5em;
  }

  &.ant-btn-default,
  &.ant-btn-default:hover,
  &.ant-btn-default:focus {
    color: #ffffff;
  }
  white-space: normal;
`;

const Button = ({ children, style, type, size, disabled = false, fullwidth = 'false', ...rest }) => (
  <StyledButton fullwidth={fullwidth} style={style} disabled={disabled} type={type} size={size} {...rest}>
    {children}
  </StyledButton>
);

export default Button;
